export default "/assets/images/mila-product-white.webp?ed6b41c51b1ed8529fab4ac9a9a78e91";